import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import { messages } from '../../../../../messages';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import { onWhoAdditionalMatchProfileClick, onWhoAdditionalMatchProfileContextMenuClick } from '../../../../analytics';
import { getTypedJSONResultDataAssistanceService } from '../../../../utils/getTypedJSONResultData';
import { AIWhoAnswerFooter, AIWhoAnswerFooterHeader, AIWhoAnswerFooterResult, AIWhoAnswerFooterResultInfoHeader, AIWhoAnswerFooterResultInfoWrapper, AIWhoAnswerFooterResultMetadata, AIWhoAnswerFooterResultsWrapper } from './styled';
export var AIAnswerWhoFooter = function AIAnswerWhoFooter() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    onNavigate = _useAIAnswerContext.onNavigate;
  var answerString = commonAttributes.answerString;

  // answerString should have at least one result or else <AIAnswerError /> will be rendered
  var _getTypedJSONResultDa = getTypedJSONResultDataAssistanceService(answerString),
    parsedResult = _getTypedJSONResultDa.parsedResult;
  var additionalUserResults = parsedResult.slice(1);
  var numAdditionalUserResults = additionalUserResults.length;
  return numAdditionalUserResults ? /*#__PURE__*/React.createElement(AIWhoAnswerFooter, null, /*#__PURE__*/React.createElement(AIWhoAnswerFooterHeader, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.ai_answer_who_questions_footer_header, {
    values: {
      numMatches: numAdditionalUserResults
    }
  }))), /*#__PURE__*/React.createElement(AIWhoAnswerFooterResultsWrapper, null, additionalUserResults.map(function (userResult) {
    return /*#__PURE__*/React.createElement(AIWhoAnswerFooterResult, {
      key: userResult.name,
      href: userResult.profile_url || undefined,
      onClick: function onClick(event) {
        onNavigate(event);
        fireAnalyticsEvent(onWhoAdditionalMatchProfileClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
          additionalMatchUserName: userResult.name,
          additionalMatchTitle: userResult.job_title || ''
        })));
      },
      onContextMenu: function onContextMenu(event) {
        onNavigate(event);
        fireAnalyticsEvent(onWhoAdditionalMatchProfileContextMenuClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
          additionalMatchUserName: userResult.name,
          additionalMatchTitle: userResult.job_title || ''
        })));
      }
    }, /*#__PURE__*/React.createElement(Avatar, {
      src: userResult.avatar_url || undefined,
      size: "medium",
      testId: userResult.name
    }), /*#__PURE__*/React.createElement(AIWhoAnswerFooterResultInfoWrapper, null, /*#__PURE__*/React.createElement(AIWhoAnswerFooterResultInfoHeader, null, userResult.name), /*#__PURE__*/React.createElement(AIWhoAnswerFooterResultMetadata, null, userResult.job_title)));
  }))) : null;
};